import { ActionTree } from 'vuex';
import { CartState, RootState } from '../types';
import { ICart, ICartItem } from '@/models/CartModels';
import * as firebase from 'firebase';


const actions: ActionTree<CartState, RootState> = {
  loadCarts({commit, rootState}) {
    const cartsCollection = rootState.fireApp.firestore().collection('carts');
    cartsCollection.onSnapshot((snapshot) => {
      const carts: ICart[] = [];

      snapshot.forEach((item) => {
        const cart = item.data() as ICart;
        cart.title = item.id;
        carts.push(cart);
      });

      commit('setCarts', carts);
    });
  },
  add({rootState}, cart: ICart): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      const cartsCollection = rootState.fireApp.firestore().collection('carts');
      if (!cart.items) {
        cart.items = [];
      }
      const id = cart.title;
      delete cart.title;
      cartsCollection.doc(id).set(cart).then(() => {
        resolve(true);
      }).catch((err) => {
        resolve(false);
      });
    });
  },
  addItem({rootState}, payload) {
    const cartsCollection = rootState.fireApp.firestore().collection('carts');

    cartsCollection.doc(payload.cart.title).update({
      items: firebase.firestore.FieldValue.arrayUnion(payload.item),
    });
  },
  setViewedCartId({commit}, id: string) {
    commit('setViewedCartId', id);
  },
  deleteSelected({rootState}, payload) {
    const cartsCollection = rootState.fireApp.firestore().collection('carts');

    cartsCollection.doc(payload.cart.title).update({
      items: payload.cart.items.filter((item: ICartItem) => !item.selected),
    });
  },
};

export default actions;
